<nz-spin [nzSpinning]="isSpinning">
  <div class="sales-portal-container">
    <div class="title-section">
      <div class="title">Turnover Overview</div>
      <nz-date-picker
        nzMode="year"
        [nzAllowClear]="false"
        [(ngModel)]="targetYear"
        (ngModelChange)="handleDateChange($event)"
      ></nz-date-picker>
    </div>
    <div class="target-section-detail">
      <sp-circular-progress
        [text]="'Achievement Rate'"
        [progress]="salesPortalService.dealerTargetSummaryInfo.procurementAchievedRate"
        class="circle-progress"
      ></sp-circular-progress>
      <div class="center">
        <div class="still-to-go">
          <span class="key">Still to GO</span>
          <span class="value"
                [class.value-0]="salesPortalService.dealerTargetSummaryInfo.procurementStillToGo === 0">
            {{
              salesPortalService.formatThousands(
                salesPortalService.dealerTargetSummaryInfo.procurementStillToGo,
                true
              )
            }}
            <span class="unit">(AUD)</span></span>
        </div>
        <div class="card-item-row">
          <div class="card-item">
            <div class="header header-light"></div>
            <div class="content-key">YTD Target Turnover</div>
            <div
              class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.ytdProcurement, true) }}
              <span class="unit">(AUD)</span></div>
          </div>
          <div class="card-item">
            <div class="header"></div>
            <div class="content-key">In Warehouse Processing</div>
            <div
              class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.inWarehouseProcessingProcurement, true) }}
              <span class="unit">(AUD)</span></div>
          </div>
        </div>
        <div class="card-item-row">
          <div class="card-item">
            <div class="header header-dark"></div>
            <div class="content-key">YTD Actual Turnover</div>
            <div
              class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.actualProcurement, true) }}
              <span class="unit">(AUD)</span></div>
          </div>
          <div class="card-item">
            <div class="header"></div>
            <div class="content-key">Open</div>
            <div
              class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.openedProcurement, true) }}
              <span class="unit">(AUD)</span></div>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="right">
        <div class="white-space"></div>
        <div class="card-item-row">
          <div class="card-item">
            <div class="header"></div>
            <div class="content-key">Turnover Target</div>
            <div
              class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.targetProcurement, true) }}
              <span class="unit">(AUD)</span></div>
          </div>
        </div>
        <div class="card-item-row">
          <div class="card-item">
            <div class="header"></div>
            <div class="content-key">Target Achieved Dealer Quantity</div>
            <div class="content-value">{{ salesPortalService.dealerTargetSummaryInfo.procurementAchievedCount }}
              / {{ salesPortalService.dealerTargetSummaryInfo.dealerCount }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="title-section" style="margin-top: 40px">
      <div class="title">Procurement</div>
    </div>
    <!--Search-->
    <form [formGroup]="searchFormData">
      <div nz-row [nzGutter]="20">
        <div nz-col [nzSpan]="8">
          <nz-form-item class="search-form-item">
            <nz-form-label>Search</nz-form-label>
            <nz-form-control class="line">
              <div nz-row [nzGutter]="20">
                <div nz-col [nzSpan]="24">
                  <nz-input-group [nzSuffix]="suffixTemplateInfo">
                    <input nz-input type="text" formControlName="searchStr" placeholder="Dealer Code/Dealer Name"/>
                    <ng-template #suffixTemplateInfo>
                      <i class="search" (click)="handleSearch()"></i>
                    </ng-template>
                  </nz-input-group>
                </div>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="8">
          <nz-form-item class="search-form-item">
            <nz-form-label>Whether Target Achieved</nz-form-label>
            <nz-form-control class="line">
              <nz-select formControlName="procurementTargetAchieved"
                         [nzSuffixIcon]="suffixSearch"
                         (ngModelChange)="getList()"
              >
                <nz-option nzValue="" nzLabel="All"></nz-option>
                <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
                <nz-option [nzValue]="false" nzLabel="No"></nz-option>
              </nz-select>
              <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzSpan]="8">
          <nz-form-item class="search-form-item">
            <nz-form-label>Whether Configuration Completed</nz-form-label>
            <nz-form-control class="line">
              <nz-select formControlName="procurementConfigurationCompleted"
                         [nzSuffixIcon]="suffixSearch"
                         (ngModelChange)="getList()"
              >
                <nz-option nzValue="" nzLabel="All"></nz-option>
                <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
                <nz-option [nzValue]="false" nzLabel="No"></nz-option>
              </nz-select>
              <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
    <!--Table-->
    <nz-table
      #basicTable
      [nzData]="listOfData"
      [nzScroll]="{ x: scrollX }"
      [nzFrontPagination]="false"
      nzTableLayout="fixed"
    >
      <thead>
      <tr>
        <th nzWidth="110px">Dealer Code</th>
        <th nzWidth="130px">Dealer Org Code</th>
        <th nzWidth="160px">Dealer Channel Code</th>
        <th nzWidth="110px">Dealer Name</th>
        <th nzWidth="110px">Dealer Area</th>
        <th [nzSortFn]="sortFn.turnoverTarget" nzWidth="140px">Turnover Target</th>
        <th [nzSortFn]="sortFn.ytdTurnoverTarget" nzWidth="170px">YTD Turnover Target</th>
        <th [nzSortFn]="sortFn.currentTurnover" nzWidth="150px">Current Turnover</th>
        <th [nzSortFn]="sortFn.stillToGo" nzWidth="140px">Still To Go</th>
        <th nzWidth="180px">Whether Target Achieved</th>
        <th nzWidth="230px">Whether Configuration Completed</th>
        <th nzRight nzWidth="100px">Action</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of basicTable.data">
        <td>{{ data.dealerCode }}</td>
        <td>{{ data.dealerOrgCode }}</td>
        <td>{{ data.dealerChannelCode }}</td>
        <td>{{ data.dealerName }}</td>
        <td>{{ data.dealerArea }}</td>
        <td nzEllipsis>{{ salesPortalService.formatThousands(data.targetProcurement, true) }}</td>
        <td nzEllipsis>{{ salesPortalService.formatThousands(data.ytdProcurement, true) }}</td>
        <td nzEllipsis>{{ salesPortalService.formatThousands(data.actualProcurement, true) }}</td>
        <td nzEllipsis>{{ salesPortalService.formatThousands(data.procurementStillToGo, true) }}</td>
        <td>{{ data.procurementStillToGo === 0 ? 'Yes' : 'No' }}</td>
        <td>{{ data.turnoverSplitStatus === 'Y' ? 'Yes' : 'No' }}</td>
        <td nzRight>
          <svg-icon [iconName]="'sales-portal-view-more.svg'" [size]="24" class="table-action-button"
                    (click)="handleToDetail(data)" title="view more"></svg-icon>
          <svg-icon [iconName]="'sales-portal-settings.svg'" [size]="24" class="table-action-button"
                    (click)="handleToSetting(data)" title="setting"></svg-icon>
        </td>
      </tr>
      </tbody>
    </nz-table>
  </div>
</nz-spin>

